<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Reasignacion
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.jpeg', style='height: auto;width: 200px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Reasignación de Vendedores
    v-flex(xs12)
      template
        v-dialog(v-model='dialog', persistent max-width='700px')
              v-btn.mb-2(v-if="cre" slot='activator', style="border-radius:5px;background-color:#012147;") Nueva reasignación
              v-container(style='background-color:white !important;max-width: 700px;')
                v-card-title.justify-center
                    span.headline Reasignación
                div(style="margin-top: 20px;")
                    v-flex(xs12 sm12)
                        v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-flex(xs6)
                              v-form(enctype="multipart/form-data")

                                v-combobox(outline
                                :items='vendedores'
                                v-model="form.vendedorA"
                                prepend-inner-icon="description"
                                label="Vendedor Saliente:")

                                v-combobox(outline
                                :items='vendedoresB'
                                v-model="form.vendedorB"
                                prepend-inner-icon="description"
                                label="Vendedor Entrante:")


                                div
                                  v-flex(v-if="loading === true", xs12 sm12 md12)
                                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                      v-progress-circular(indeterminate='', color='primary')
                                  v-flex(v-if="loading === false", xs12 sm12 md12)
                                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                      v-btn(style="background:#012147;border-radius:10px;", @click.native='save') Guardar
                                      v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir

        v-layout(align-start='', justify-start='', row='', fill-height='')
          v-flex(xs12 style='margin-top: 5px;')
            v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                    span.white--text Lista de Reasignaciones
            v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :items="reasignaciones" style="margin-top: 5px;")
              template(slot='items', slot-scope='props')
                td {{ props.item.fecha | moment('DD-MM-YYYY') }}
                td {{ mostrarVendedor(props.item.vendedorA) }} ({{props.item.vendedorA}})
                td {{ mostrarVendedor(props.item.vendedorB) }} ({{props.item.vendedorB}})
                td {{ props.item.usuario }}
                td(v-if="props.item.profit") No
                td(v-else) Si
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "Reasignacion",
  components: {},
  data: () => ({
    loading: false,
    dialog4: false,
    form: {
      vendedorA: "",
      vendedorB: "",
      usuario: ""
    },
    pagination: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    dialog: false,
    reasignaciones: [],
    vendedores: [],
    ruta: serverImg,
    headers: [
      { text: "Fecha", value: "fecha" },
      { text: "Vendedor S.", value: "vendedorA" },
      { text: "Vendedor E.", value: "vendedorB" },
      { text: "Usuario", value: "usuario" },
      { text: "Sincronización", value: "profit" }
    ],
    defaultForm: {
      vendedorA: "",
      vendedorB: "",
      usuario: ""
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  computed: {
    vendedoresB() {
        return this.vendedores.filter((el)=> el.value !== this.form.vendedorA )
    }
  },
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.adminavaflex.permisos.length; i++) {
        if (this.$store.state.adminavaflex.permisos[i].ruta === "Reasignacion de vendedor") {
          for (
            let j = 0;
            j < this.$store.state.adminavaflex.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminavaflex.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminavaflex.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminavaflex.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    async obtenerReasignaciones() {
        return await new Promise(async resolve => {
            Api.get("reasignacion").then(res => {
                this.reasignaciones = res.data;
                resolve("S")
            });
        })
    },
    async obtenerVendedores() {
        return await new Promise(async resolve => {
            Api.get("vendedor/all").then(res => {
                this.vendedores = [];
                if (res.data && res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        const el = res.data[i];
                        this.vendedores.push({text: el.ven_des.trim(), value: el.co_ven.trim()})
                    }
                }
                resolve("S")
            });
        })
    },
    async initialize() {
      this.dialog4 = true;
      await this.obtenerVendedores()
      await this.obtenerReasignaciones()
      this.dialog4 = false;
    },
    mostrarVendedor(item) {
        const vendedor = this.vendedores.find(el => el.value.trim() === item);
        return vendedor ? vendedor.text : "";
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.initialize();
    },
    save() {
      this.loading = true;
      if (this.form.vendedorA && this.form.vendedorB) {
        this.form.vendedorA = this.form.vendedorA.value
        this.form.vendedorB = this.form.vendedorB.value
        this.form.usuario = this.$store.state.adminavaflex.nombre + " " + this.$store.state.adminavaflex.apellido
        Api.post("reasignacion", this.form)
          .then(res => {
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Registro realizado exitosamente.",
              "success"
            );
            this.close();
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$message.error("A ocurrido un error." + err);
          });
      } else {
        this.$swal.fire(
            "¡Atención!",
            "Debe ingresar los datos solicitados para continuar con la operación.",
            "success"
        );
      }
    }
  }
};
</script>
